import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const UserInitInfo = {
  state: {
    //储存token
    token: sessionStorage.getItem("token")
      ? sessionStorage.getItem("token")
      : "",
    // 存储value :md5(md5(password)+token) || md5(appId+token)
    Authorization: localStorage.getItem("Authorization")
      ? sessionStorage.getItem("Authorization")
      : ""
  },
  mutations: {
    /**
     * 修改value，并将token存入localStorage
     */
    changeLonginToken(state, token) {
      state.LonginToken = token;
      sessionStorage.setItem("token", token);
    },

    /**
     * 修改value，并将token存入localStorage
     */
    changeAuthorization(state, value) {
      state.Authorization = value;
      sessionStorage.setItem("Authorization", value);
    },

    /**
     * 用户退出清除用户信息
     */
    logout(state) {
      sessionStorage.removeItem("userInfo");
      state.user = "";
    }
  },
  actions: {}
};
export default UserInitInfo;
